<template>
  <div class="home"></div>
</template>

<script>
export default {
	name: 'home',
	mounted() {
		const width = document.body.clientWidth;
    if(width > 850) {
      this.$router.push({name: 'p-index'});
    } else {
      this.$router.push({name: 'm-index'});
    }
	},
}
</script>